import { render, staticRenderFns } from "./fiveStars.vue?vue&type=template&id=0c30c30c&scoped=true"
import script from "./fiveStars.vue?vue&type=script&lang=js"
export * from "./fiveStars.vue?vue&type=script&lang=js"
import style0 from "./fiveStars.vue?vue&type=style&index=0&id=0c30c30c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30c30c",
  null
  
)

export default component.exports